import { GetCheckoutResponse } from '@wix/ambassador-ecom-v1-checkout/types';
import { CheckoutService } from '../services/CheckoutService';
import { GetWalletDetailsResponse } from '@wix/ambassador-rise-integration-v1-wix-integration-provider/types';
import {
  ControllerFlowAPI as CFlowAPI,
  PlatformControllerFlowAPI,
} from '@wix/yoshi-flow-editor';

export type ControllerState = {
  checkoutService: CheckoutService;
  status: ApplicationStatus;
  checkoutSlotProps?: CheckoutSlotProps;
  checkoutInfo?: GetCheckoutResponse;
  wallet?: GetWalletDetailsResponse;
};

export type CheckoutSlotProps = {
  checkoutId: string;
  refreshCheckoutCallback: () => Promise<void>;
  checkoutUpdatedDate: string;
};

export type ErrorDetailsFragment = {
  applicationError?: {
    code?: string | null;
    description?: string | null;
    data?: any | null;
  } | null;
};

export interface ErrorData {
  message: string;
  details: ErrorDetailsFragment;
}

export enum ApplicationStatus {
  INITIALIZING = 'initializing',
  UPDATING = 'updating',
  IDLE = 'idle',
  Disabled = 'disabled',
  REDEEMED = 'redeemed',
}

export enum BIClickEvents {
  APPLY = 'apply',
  COLLAPSE = 'collapse',
  EXPAND = 'expand',
}

export type ControllerFlowAPI = CFlowAPI | PlatformControllerFlowAPI;
